import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();



  return (
    <footer className="text-white footer-bg">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/logo.png"
                alt="Dawoodi Bohra Logo"
                className="h-10 w-auto object-contain"
              />
              <span className="font-playfair text-xl font-bold">Anjuman e Burhani NJ</span>
            </div>
            <p className="text-white/80 font-poppins text-sm">
              A community dedicated to faith, tradition, and service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
          </div>

          <div></div>


          {/* Contact Info */}
          <div>
            <h3 className="font-playfair text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-dawoodi-gold mt-0.5 flex-shrink-0" />
                <span className="text-white/80">341 Dunhams Corner Rd<br />East Brunswick, NJ 08816</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-dawoodi-gold flex-shrink-0" />
                <a href="tel:+17323904214" className="text-white/80 hover:text-dawoodi-gold transition-colors">
                  (732) 390-4214
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-dawoodi-gold flex-shrink-0" />
                <a href="mailto:pr@njjamaat.org" className="text-white/80 hover:text-dawoodi-gold transition-colors">
                  pr@njjamaat.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-white/60 font-poppins text-sm">
            &copy; {currentYear} Anjuman-e-Burhani
          </p>
          <div className="flex space-x-6 text-white/60 font-poppins text-sm">
            <a href="/privacy" className="hover:text-dawoodi-gold transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-dawoodi-gold transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
